<template>
	<modal-dialog :visible="visible" @close="close">
		<template v-slot:header>Download a Template</template>
		<template v-slot:body>
			<p class="text">The format of the financial data must follow a specified Excel template.</p>
			<hr/>
			<h3>New Investment</h3>
			<p class="text">Start 'from scratch' with a blank template</p>
			<div class="d-flex justify-content-end">
				<a class="btn btn-secondary" href="#" v-on:click.prevent="downloadTemplate">Download Blank Template</a>
			</div>
			<hr/>
			<h3>Existing Investment</h3>
			<p class="text">Download the latest spreadsheet for an existing investment and add the appropriate columns to the financials sheet</p>

			<div class="d-flex justify-content-md-between">
				<drop-down :options="companies" v-on:option-selected="onCompanySelected"></drop-down>
				<a class="btn btn-secondary" href="#" v-on:click.stop v-on:click.prevent="downloadFile" :class="{disabled: noSelectedCompany}" v-bind:data-upload-id="latestUploadId" v-bind:data-filename="companyFinancialsFileName">Download Last Spreadsheet</a>
			</div>
			<div class="field-error" v-if="showNoDownloadsError"><p>Company does not have any uploaded spreadsheets</p></div>
		</template>
	</modal-dialog>

</template>

<script type="text/javascript">

	import ModalDialog from "@/views/shared/ModalDialog";
	import DropDown from "@/views/shared/DropDown";
	import FileDownload from "@/mixins/FileDownload";
	import {UploadsApi} from "@/api/uploads_api";

	export default {
		name: 'DownloadTemplateModal',
		inheritAttrs: false,
		emits: ['close'],
		mixins: [FileDownload],

		components: {
			ModalDialog,
			DropDown
		},

		filters: {
		},

		provide: function() {
			return {
			}
		},

		inject: [],

		props: ['visible','companies'],

		data() {
			return {
				selectedCompanyId: null,
				latestUploadId: null,
				companyFinancialsFileName: null
			}
		},

		computed: {
			noSelectedCompany() {
				return this.latestUploadId == null
			},
			showNoDownloadsError() {
				return this.selectedCompanyId != null && this.latestUploadId == null
			}
		},

		watch: {

		},

		created() {
		},

		mounted() {
		},

		methods: {
			close() {
				this.$emit('close');
			},

			async onCompanySelected(companyId) {
				this.selectedCompanyId = companyId
				try {
					const latestUpload = await UploadsApi.getLatestCompleteUpload(companyId)
					if (latestUpload) {
						this.latestUploadId = latestUpload.guid
						this.companyFinancialsFileName = latestUpload.fileName
					} else {
						this.latestUploadId = null
						this.companyFinancialsFileName = null
					}
				} catch (e) {
					if (e && e.status === 404) {
						this.latestUploadId = null
						this.companyFinancialsFileName = null
					} else {
						throw e
					}
				}
			},
			async downloadTemplate() {
				try {
					await UploadsApi.downloadTemplate()
				} catch (e) {
					console.error('Template download failed:', e)
				}
			}
    }
	}
</script>

<style lang="scss">
</style>
